import React, { useState } from 'react';
import { InlineWidget, useCalendlyEventListener } from 'react-calendly';

import Icon from '../Icon';

export function Calendly({ pushEventTo, url, eventScheduled, onChange, target, readonly }) {
  const targetEl = document.getElementById(target);

  const [height, setHeight] = useState('500px');
  const [isEventScheduled, setIsEventScheduled] = useState(eventScheduled);

  useCalendlyEventListener({
    onProfilePageViewed: () => console.log('onProfilePageViewed'),
    onDateAndTimeSelected: () => console.log('onDateAndTimeSelected'),
    onEventTypeViewed: () => console.log('onEventTypeViewed'),
    onEventScheduled: e => {
      pushEventTo(targetEl, onChange, {
        event: e.data.payload.event,
        invitee: e.data.payload.invitee,
        event_scheduled: true,
      });
      setIsEventScheduled(true);
    },
    onPageHeightResize: e => setHeight(e.data.payload.height),
  });

  if (isEventScheduled) {
    return (
      <div className='my-5'>
        <div className='mx-auto flex size-9 items-center justify-center rounded-full bg-green-100'>
          <Icon name='hero-check' className='size-6 text-green-600' />
        </div>
        <div className='mt-3 text-center'>
          <h3 className='text-base font-semibold text-gray-900' id='modal-title'>
            Event scheduled
          </h3>
          <div className='mt-2'>
            <p className='text-sm text-gray-500'>Thank you for booking an event.</p>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <InlineWidget className='focus:outline-hidden z-10' styles={{ height }} url={url} />
      </>
    );
  }
}
